const getStyles = (breakpoints) => {
  const { isTablet, isMobileL, isMobileM, isMobileS, isMobileXS } = breakpoints;

  // Base styles
  const styles = {
    overlayContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      paddingTop: '80px',
      pointerEvents: 'none'
    },
    contentWrapper: {
      position: 'absolute',
      top: '15px',
      left: '8%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: '1200px',
      padding: '14px 24px',
      borderRadius: '50px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '25px',
      textAlign: 'center',
      zIndex: 1000,
      pointerEvents: 'none'
    },
    textContainer: {
      position: 'relative',
      width: '100%',
      pointerEvents: 'none'
    },
    animatedText: {
      fontSize: '38px',
      fontWeight: '900',
      color: '#ffffff',
      textShadow: '0 5px 20px rgba(0,0,0,0.4), 0 0 30px rgba(109,213,250,0.8)',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      justifyContent: 'center',
      flexWrap: 'wrap',
      filter: 'drop-shadow(0 0 15px rgba(109,213,250,0.5))',
      pointerEvents: 'auto'
    },
    wordSpan: {
      display: 'inline-block',
      transformStyle: 'preserve-3d',
      cursor: 'pointer',
      position: 'relative'
    },
    wordUnderline: {
      position: 'absolute',
      bottom: '-5px',
      left: 0,
      right: 0,
      height: '3px',
      background: 'linear-gradient(90deg, #6dd5fa, #a855f7)',
      borderRadius: '2px',
      transformOrigin: 'left'
    },
    buttonContainer: {
      position: 'relative',
      perspective: '1000px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '30px',
      pointerEvents: 'none'
    },
    ctaButton: {
      background:
        'linear-gradient(135deg, #6a62ff 0%, #0db7f3 50%, #6a62ff 100%)',
      backgroundSize: '200% 200%',
      border: '2px solid rgba(255,255,255,0.3)',
      padding: '10px 30px',
      borderRadius: '50px',
      color: 'white',
      fontWeight: '900',
      fontSize: '18px',
      cursor: 'pointer',
      boxShadow:
        '0 15px 40px rgba(106, 98, 255, 0.6), inset 0 2px 0 rgba(255,255,255,0.4), inset 0 -2px 0 rgba(0,0,0,0.2)',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      position: 'relative',
      overflow: 'hidden',
      transformStyle: 'preserve-3d',
      perspective: '1000px',
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      pointerEvents: 'auto'
    },
    buttonContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      zIndex: 1
    },
    buttonIcon: {
      fontSize: '32px',
      filter: 'drop-shadow(0 0 10px rgba(255,255,255,0.8))',
      position: 'relative',
      zIndex: 1
    },
    buttonText: {
      position: 'relative',
      zIndex: 1,
      fontSize: '16px',
      fontWeight: '900',
      color: '#ffffff',
      lineHeight: '1.3',
      textAlign: 'center',
      textShadow: '0 2px 4px rgba(251, 224, 224, 0.2)'
    },
    startNowText: {
      fontSize: '16px',
      fontWeight: '900',
      color: '#ffffff',
      cursor: 'pointer',
      zIndex: 2000,
      padding: '8px 12px',
      borderRadius: '20px',
      background: 'rgba(0,0,0,0.25)',
      backdropFilter: 'blur(6px)',
      display: 'inline-block',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      transition: 'all 0.3s ease-in-out',
      pointerEvents: 'auto'
    }
  };
  if (isTablet) {
    // 768px
    styles.contentWrapper.left = '6%';
    styles.contentWrapper.width = '90%';
    styles.contentWrapper.gap = '8px';
    styles.animatedText.fontSize = '12px';
    styles.animatedText.gap = '4px';
    styles.ctaButton.padding = '5px 35px';
    styles.ctaButton.fontSize = '10px';
    styles.buttonText.fontSize = '8px';
    styles.buttonIcon.fontSize = '10px';
    styles.startNowText.fontSize = '10px';
    styles.startNowText.padding = '4px 16px';
  }

  if (isMobileL) {
    // 425px
    styles.contentWrapper.padding = '10px 15px';
    styles.animatedText.fontSize = '12px';
    styles.animatedText.gap = '6px';
    styles.ctaButton.padding = '4px 16px';
    styles.ctaButton.fontSize = '10px';
    styles.buttonText.fontSize = '8px';
    styles.buttonIcon.fontSize = '10px';
    styles.startNowText.fontSize = '10px';
    styles.startNowText.padding = '4px 16px';
  }

  if (isMobileM) {
    // 375px
    styles.animatedText.fontSize = '10px';
    styles.ctaButton.padding = '8px 20px';
    styles.buttonText.fontSize = '7px';
    styles.buttonIcon.fontSize = '10px';
    styles.startNowText.fontSize = '8px';
    styles.startNowText.padding = '4px 16px';
  }

  if (isMobileS) {
    // 360px
    styles.animatedText.fontSize = '12px';
    styles.contentWrapper.gap = '15px';
    styles.ctaButton.fontSize = '10px';
    styles.buttonText.fontSize = '8px';
    styles.buttonIcon.fontSize = '10px';
    styles.startNowText.fontSize = '8px';
    styles.startNowText.padding = '4px 16px';
  }

  if (isMobileXS) {
    // 320px
    styles.animatedText.fontSize = '10px';
    styles.ctaButton.padding = '6px 15px';
    styles.buttonText.fontSize = '8px';
    styles.buttonIcon.fontSize = '8px';
    styles.contentWrapper.padding = '8px 10px';
    styles.startNowText.fontSize = '8px';
    styles.startNowText.padding = '4px 16px';
  }

  return styles;
};

export default getStyles;
